import { Skeleton } from 'antd';
import React from 'react';

export type TableSkeletonProps = {
  rows?: number;
  columns?: number;
  columnWidths?: Array<string | number>;
  rowHeight?: number;
  gap?: number;
  showPagination?: boolean;
  paginationWidth?: number;
  paginationHeight?: number;
  marginTop?: number;
  // legacy, kept for backward compatibility (no longer used directly)
  tableHeight?: number;
};

/**
 * TableSkeleton: Esqueleto reutilizable para tablas con filas y columnas en grid.
 * Muestra placeholders alineados con la cabecera de la tabla mientras se cargan datos.
 */
const TableSkeleton = ({
  rows = 12,
  columns = 7,
  columnWidths,
  rowHeight = 20,
  gap = 16,
  showPagination = true,
  paginationWidth = 320,
  paginationHeight = 48,
  marginTop = 16
}: TableSkeletonProps) => {
  const gridTemplate =
    columnWidths && columnWidths.length === columns
      ? columnWidths.map((w) => (typeof w === 'number' ? `${w}px` : String(w))).join(' ')
      : new Array(columns).fill('1fr').join(' ');

  return (
    <>
      <div
        style={{
          width: '100%',
          marginTop,
          display: 'grid',
          gridTemplateColumns: gridTemplate,
          rowGap: gap,
          columnGap: gap
        }}>
        {Array.from({ length: rows }).map((_, rowIndex) =>
          Array.from({ length: columns }).map((__, colIndex) => (
            <Skeleton.Node key={`${rowIndex}-${colIndex}`} active style={{ height: rowHeight }} />
          ))
        )}
      </div>
      {showPagination && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop }}>
          <Skeleton.Node active style={{ width: paginationWidth, height: paginationHeight }} />
        </div>
      )}
    </>
  );
};

export default TableSkeleton;
